
import React from "react";
import {RESIDENTS_TABS_MODEL} from "../../Model/Model";
import CustomTab from "../../../../components/CustomTab";
import CustomTabContainer from "../../../../components/CustomTabContainer";
import ResidentsRegistered from "./ResidentsRegistered";
import ResidentsWhiteList from "./ResidentsWhiteList";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import {PlusIconsOptions} from "../../../../components/buttons/IconButtons";
import AddToWhiteListModal from "../../Modal/AddToWhiteListModal";
import {ResidentsTabsApp} from "../../Functionality/ResidentsTabsApp";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 */
const ResidentsTabs = ({
    t,
    buildingDetail,
    setModified
}) => {
    const {
        canManageResidents,
        selectedTab,
        setSelectedTab,
        whiteListModal,
        setWhiteListModal,
        refresh,
        counts,
        handleTotalChange,
        handleSaved
    } = ResidentsTabsApp({ buildingId: buildingDetail?.id, setModified });

    return (
        <div className="overflow-hidden d-flex flex-column flex-grow-1 min-h-0">
            <CustomTabContainer
                activeTab={selectedTab}
                setActiveTab={(e) => {
                    setSelectedTab(e);
                }}
                className="border-0 px-0"
                paddingClass=''
                buttonAction={
                    canManageResidents &&
                    selectedTab === RESIDENTS_TABS_MODEL.WHITE_LIST.key &&
                        <ButtonAction
                            id='btn_rt_add_white_list'
                            name='add'
                            className='btn-icon-add'
                            Icon={PlusIconsOptions}
                            splitName={false}
                            disabled={false}
                            onClick={() => setWhiteListModal(true)}
                        />
                }
            >
                {Object.values(RESIDENTS_TABS_MODEL).map((item) => (
                    <CustomTab
                        key={item.key}
                        id={item.key}
                        title={t(item.translation)}
                        icon={item?.icon}
                        newsNumber={counts?.[item.key]}
                        selected={selectedTab === item.key}
                        onClick={() => {
                            setSelectedTab(item.key)
                        }}
                    />
                ))}
            </CustomTabContainer>

            <div className="flex-grow-1 min-h-0 d-flex flex-column">
                {selectedTab === RESIDENTS_TABS_MODEL.REGISTERED.key ? (
                    <ResidentsRegistered
                        buildingDetail={buildingDetail}
                        refresh={refresh}
                        onTotalChange={(total) =>
                            handleTotalChange(RESIDENTS_TABS_MODEL.REGISTERED.key, total)}
                    />
                ) : (
                    <ResidentsWhiteList
                        buildingDetail={buildingDetail}
                        refresh={refresh}
                        onTotalChange={(total) =>
                            handleTotalChange(RESIDENTS_TABS_MODEL.WHITE_LIST.key, total)}
                    />
                )}
            </div>

            <AddToWhiteListModal
                show={whiteListModal}
                onHide={() => setWhiteListModal(false)}
                onSaved={handleSaved}
                buildingId={buildingDetail?.id}
            />

        </div>
    );

}

export default ResidentsTabs
